import * as TYPES from './action-types';

export const setUser = data => ({
  type: TYPES.SET_USER,
  data,
});